var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#a)","fillRule":"evenodd","clipRule":"evenodd","fill":"#000","key":0},[React.createElement("path",{"d":"M13 1.5H8A1.5 1.5 0 0 0 6.5 3v5A1.5 1.5 0 0 0 8 9.5h5A1.5 1.5 0 0 0 14.5 8V3A1.5 1.5 0 0 0 13 1.5ZM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H8Z","key":0}),React.createElement("path",{"d":"M5 6.5H3A1.5 1.5 0 0 0 1.5 8v5A1.5 1.5 0 0 0 3 14.5h5A1.5 1.5 0 0 0 9.5 13v-2H8c-1.683 0-3-1.367-3-3V6.5ZM3 5a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V9.5H8c-.84 0-1.5-.681-1.5-1.5V5H3Z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M0 0h16v16H0z"})))]);
}

InlineSvg.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
